import { getCargoLoss as getCargoLossApi } from '../models/common-api';

const state = {
  showMsgBox: false,
  reportCaseData: null, // 报案缓存数据
  accidentList: null, // 货险原因数据
  cargoLossList: [], // 货损数据
  cityList: null, // 城市列表
  orderinfo: null, // 订单相关
  goodsTypeList: null, // 货物类型
  accidentDescList: null, // 货损原因
  /**
   * 保存开户银行选择器数据
   * {
   *  1595842991553417468 : {
   *    bank_type_code: “308”
   *    bank_type_name: "招商银行"
   *  }
   * }
   */
  bankPools: {},
  responsiblePools: {},
  /**
   * 保存选择器选择的所有货物类型, 结构如下
   * {
   *  1595835657910832464: {
   *    cargo_type_code: "JJJZ"
   *    cargo_type_name: "家具家装（植物及其产品）"
   *    cargo_feature_code: "MZ"
   *    cargo_feature_name: "木质类家具家装"
   * }
   */
  cargoTypePools: {},
  /**
   * 保存选择器选择的所有货损情况, 结构如下
   * {
   *  1595835657910832464: {
   *    cargo_accident_code: "FC"
   *    cargo_accident_name: "车辆翻车、碰撞"
   *    cargo_loss_form_code: "PSZD"
   *    cargo_loss_form_name: "破损、折断"
   * }
   */
  cargoLossPools: {},
  allCargoLossList: [], // 所有货物类型数据
  /**
   * 保存选择的订单数据
   * 1595835657910832464: {
   *    order_display_id: '56694389438'
   * }
   */
  orderPools: {},
};

// getters
const getters = {
  getShowMsgBox: (state) => state.showMsgBox,
  getReportCaseData: (state) => state.reportCaseData,
  getAccidentList: (state) => state.accidentList,
  getCargoLossList: (state) => state.cargoLossList,
  getCityList: (state) => state.cityList,
  getOrderInfo: (state) => state.orderinfo,
  goodsTypeList: (state) => state.goodsTypeList,
  // goodsAccidentList: state => state.goodsAccidentList,
  accidentDescList: (state) => state.accidentDescList,
  cargoLossList: (state) => state.cargoLossList,
  allCargoLossList: (state) => state.allCargoLossList,
  bankPools: (state) => state.bankPools,
  cargoTypePools: (state) => state.cargoTypePools,
  cargoLossPools: (state) => state.cargoLossPools,
  orderPools: (state) => state.orderPools,
  responsiblePools: (state) => state.responsiblePools,
};

// mutations
const mutations = {
  saveShowMsgBox(state, showMsgBox) {
    state.showMsgBox = showMsgBox;
  },
  saveReportCaseData(state, reportCaseData) {
    state.reportCaseData = reportCaseData;
    localStorage.setItem('reportCaseData', JSON.stringify(reportCaseData));
  },
  saveAccidentList(state, accidentList) {
    state.accidentList = accidentList;
  },
  saveCargoLossList(state, cargoLossList) {
    state.cargoLossList = cargoLossList;
  },
  saveCityList(state, cityList) {
    state.cityList = cityList;
  },
  saveOrderInfo(state, orderInfo) {
    state.orderinfo = orderInfo;
  },
  setGoodsTypeList(state, goodsTypeList) {
    state.goodsTypeList = goodsTypeList;
  },
  setAccidentDescList(state, accidentDescList) {
    state.accidentDescList = accidentDescList;
  },
  saveBankPools(state, banks) {
    if (!state.bankPools) {
      state.bankPools = {};
    }
    state.bankPools = banks;
  },
  saveResponsiblePools(state, responsible) {
    if (!state.responsiblePools) {
      state.responsiblePools = {};
    }
    state.responsiblePools = responsible;
  },
  saveAllCargoLossList(state, allCargoLossList = []) {
    state.allCargoLossList = allCargoLossList;
  },
  // 保存选择的货损类型
  saveCargoTypes(state, cargoTypes) {
    if (!state.cargoTypePools) {
      state.cargoTypePools = {};
    }
    state.cargoTypePools = cargoTypes;
  },
  // 保存选择的货损情况
  saveCargoLosses(state, cargoLosses) {
    if (!state.cargoLossPools) {
      state.cargoLossPools = {};
    }
    state.cargoLossPools = cargoLosses;
  },
  // 保存选择的订单
  saveSelectOrders(state, orders) {
    if (!state.orderPools) {
      state.orderPools = {};
    }
    state.orderPools = orders;
  },
};

// actions
const actions = {
  // 所有货物类型列表
  getAllCargoLossList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      if (state.allCargoLossList && state.allCargoLossList.length) {
        return resolve(state.allCargoLossList);
      }
      getCargoLossApi(params).then((res) => {
        if (res.data.ret === 0) {
          commit('saveAllCargoLossList', res.data.data);
          return resolve(res.data.data);
        }
      });
    });
  },

  // 保存选择的开户行
  addBank({ commit, state }, { key, bank }) {
    if (!state.bankPools) {
      state.bankPools = {};
    }
    console.log(key, bank);
    commit('saveBankPools', {
      ...state.bankPools,
      [key]: bank,
    });
  },
  // 保存选择的责任人
  addResponsible({ commit, state }, { key, responsible }) {
    if (!state.responsiblePools) {
      state.responsiblePools = {};
    }
    console.log(key, responsible);
    commit('saveResponsiblePools', {
      ...state.responsiblePools,
      [key]: responsible,
    });
  },

  // 增加选择的货损类型
  addCargoType({ commit, state }, { key, cargo }) {
    if (!state.cargoTypePools) {
      state.cargoTypePools = {};
    }
    commit('saveCargoTypes', {
      ...state.cargoTypePools,
      [key]: cargo,
    });
  },

  // 增加选择的货损情况
  addCargoLoss({ commit, state }, { key, loss }) {
    if (!state.cargoLossPools) {
      state.cargoLossPools = {};
    }
    commit('saveCargoLosses', {
      ...state.cargoLossPools,
      [key]: loss,
    });
  },

  // 增加选择的订单
  addSelectOrder({ commit, state }, { key, order }) {
    if (!state.orderPools) {
      state.orderPools = {};
    }
    commit('saveSelectOrders', {
      ...state.orderPools,
      [key]: order,
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
